import { render, staticRenderFns } from "./TwitchConnect.vue?vue&type=template&id=29c4a7aa&scoped=true&"
import script from "./TwitchConnect.vue?vue&type=script&lang=js&"
export * from "./TwitchConnect.vue?vue&type=script&lang=js&"
import style0 from "./TwitchConnect.vue?vue&type=style&index=0&id=29c4a7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c4a7aa",
  null
  
)

export default component.exports